var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_down_1920957",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.486,
    height: 10.372,
    viewBox: "0 0 15.486 10.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    d: "M11.359,28.059l6.274-7.447A1.468,1.468,0,0,0,16.508,18.2H3.961a1.47,1.47,0,0,0-1.124,2.412L9.11,28.059A1.488,1.488,0,0,0,11.359,28.059Z",
    transform: "translate(-2.493 -18.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.394cb40f6f0748f23b6844d60ab27245.svg";
export { ForwardRef as ReactComponent };